export function extend(props) {
    // eslint-disable-next-line no-invalid-this
    const parent = this;

    const Child = function (...args) {
        parent.apply(this, args);

        if (typeof this.init === 'function') {
            this.init(...args);
            if (parent.collectionMvc) {
                this._setHandlers();
            }
        }

        if (typeof this._initReady === 'function') {
            this._initReady();
        }
    };

    Child.extend = parent.extend;
    Child.prototype = Object.create(parent.prototype);
    Child.prototype.constructor = Child;

    Hop.mixin(Child.prototype, props);

    return Child;
}
